import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    bg-neutral-200
    [&[data-orientation=horizontal]]:h-px
    [&[data-orientation=horizontal]]:w-full
    [&[data-orientation=vertical]]:h-full
    [&[data-orientation=vertical]]:w-px
  `,
  {
    variants: {
      orientation: {
        horizontal: 'h-px w-full mt-1 mb-1 my-2',
        vertical: 'w-10px h-full ml-1 mr-1',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
    },
  }
)
